import { Box, Typography } from '@mui/material';
import { FC } from 'react';

interface AssessmentDrawerItemProp {
  question: string;
  answer: string;
}

export const AssessmentDrawerItem: FC<AssessmentDrawerItemProp> = ({
  question,
  answer,
}) => {
  return (
    <Box sx={{ mb: 1, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <Typography variant='body2' sx={{ color: 'text.secondary' }}>
        {question}
      </Typography>
      <Typography variant='body2'>{answer}</Typography>
    </Box>
  );
};
